module.exports = __webpack_public_path__ + "img/gaoya10.378b89a9.svg";